/**
 * Payload PIX mocado. Texto opaco — suficiente pra preencher o QR Code.
 * Não é PIX real, não vai funcionar em nenhum app bancário.
 *
 * Estrutura inspirada no BR Code, mas com TXID derivado do registrationId
 * pra cada registro gerar um QR único visualmente.
 */
export function generatePixPayload(amount: number, registrationId: string): string {
  const txid = registrationId.replace(/-/g, '').slice(0, 25).toUpperCase();
  const value = amount.toFixed(2);
  const valueLen = String(value.length).padStart(2, '0');
  const txidLen = String(txid.length + 4).padStart(2, '0');

  return (
    '00020126580014BR.GOV.BCB.PIX' +
    '0114+5511999999999' +
    '52040000' +
    '5303986' +
    `5403${valueLen}${value}` +
    '5802BR' +
    '5925ETERNALIZE TECH MOCK' +
    '6009SAO PAULO' +
    `62${txidLen}0510${txid}` +
    '6304'
  );
}

export function formatCurrencyBRL(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}
